import Flickity from "flickity";

function Slider(el) {
  el.classList.remove("hidden");
  const options = el.dataset?.options ? JSON.parse(el.dataset.options) : {};
  const indexEl = el.parentElement.querySelector("[data-index]");
  var currentSlide = document.getElementById("current-slide");

  const flk = new Flickity(el, options);

  function nextSlide() {
    flk.next();
  }

  function prevSlide() {
    flk.previous();
  }

  function setActiveBtn(btns, index) {
    btns.forEach((btn) => btn.classList.remove("active"));
    btns[index].classList.add("active");
  }

  if (options.customNav) {
    const btns = [
      ...document.querySelectorAll(options.customNav + " .slider-button"),
    ];

    btns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const index = btns.indexOf(btn);
        flk.select(index);
      });
    });

    setActiveBtn(btns, 0);

    flk.on("change", (index) => {
      setActiveBtn(btns, index);
    });
  }

  document
    .querySelectorAll(options?.nextButton)
    .forEach((el) => el.addEventListener("click", nextSlide));

  document
    .querySelectorAll(options?.prevButton)
    .forEach((el) => el.addEventListener("click", prevSlide));

  document.addEventListener("lazyloaded", (e) => {
    console.log("lazyloaded");
    flk.resize();
  });

  return () => {
    console.log("destroy slider ");
    flk.destroy();
  };
}

export default Slider;
